import * as ct from 'countries-and-timezones';

// Get timezones .name as a list
export const timezones = Object.values(ct.getAllTimezones()).map(tz => tz.name);